import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const OrgOverrideModalContext = createContext(null);

export function OrgOverrideModalProvider({ children }) {
  const [selectedOrganization, setSelectedOrganization] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = organization => {
    setSelectedOrganization(organization);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <OrgOverrideModalContext.Provider
      value={{
        selectedOrganization,
        isModalOpen,
        openModal,
        closeModal,
      }}
    >
      {children}
    </OrgOverrideModalContext.Provider>
  );
}

OrgOverrideModalProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useOrgOverrideModalContext() {
  return useContext(OrgOverrideModalContext);
}
